import { Switch } from '@headlessui/react';
import { 
    MailQuestion
} from 'lucide-react';

export const StatusDetailCard = ({handleStatusClick, is_active, isUpdating, updateError}) => (
    <div className="detail-card">
      <div className="detail-card-content">
        <MailQuestion className={`detail-icon ${is_active ? 'active' : 'inactive'}`} />
        <div>
          <div className="detail-label">Status</div>
          <div className="detail-value status-toggle">
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={is_active}
                onChange={() => handleStatusClick(!is_active)}
                disabled={isUpdating}
              />
              <span className="toggle-slider"></span>
            </label>
            <span className={isUpdating ? 'updating-status' : ''}>
              {is_active ? 'Active' : 'Inactive'}
            </span>
            {isUpdating && <div className="loader-spinner" />}
          </div>
          {updateError && (
            <div className="status-error">
              Failed to update status: {updateError}
            </div>
          )}
        </div>
      </div>
    </div>
  );